import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useSite } from "../../lib/site";
import { mediaUrl } from "../../lib/api";

export const NAV = [
  { to: "/equipment-trials", label: "How trials work" },
  { to: "/equipment", label: "Equipment" },
  { to: "/home-modifications", label: "Home modifications" },
  { to: "/participants-families", label: "Participants & families" },
  { to: "/referrers", label: "Referrers" },
  { to: "/ndis-funding", label: "NDIS funding" },
  { to: "/contact", label: "Contact" },
];
const EXTRA = [{ to: "/about", label: "About us" }, { to: "/faqs", label: "FAQs" }, { to: "/equipment-return", label: "Return equipment" }];

export function Logo() {
  const { settings } = useSite();
  return (
    <img src={settings.logo_url ? mediaUrl(settings.logo_url) : "/images/logo.png"} alt={settings.business_name || "Accessible Trials & Mods"}
      className="logo-img h-8 w-auto sm:h-10" width="242" height="40" data-testid="site-logo" />
  );
}

const linkCls = ({ isActive }) =>
  `whitespace-nowrap rounded-lg px-3 py-2 text-[0.95rem] font-medium transition-colors hover:bg-teal-soft hover:text-teal ${isActive ? "text-teal underline decoration-2 decoration-amber underline-offset-8" : "text-ink"}`;

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-line bg-surface/95 backdrop-blur-md">
      <div className="container-x flex min-h-[76px] items-center justify-between gap-4 min-[1800px]:max-w-[108rem]">
        <Link to="/" className="shrink-0 rounded-xl" data-testid="header-logo-link" aria-label="Accessible Trials & Mods home"><Logo /></Link>
        <nav aria-label="Main" className="hidden min-[1800px]:block">
          <ul className="flex items-center gap-0.5">
            {NAV.map((n) => (
              <li key={n.to}><NavLink to={n.to} className={linkCls} data-testid={`nav-${n.to.slice(1)}`}>{n.label}</NavLink></li>
            ))}
          </ul>
        </nav>
        <div className="ml-auto hidden items-center gap-2 md:flex min-[1800px]:ml-0">
          <Link to="/referrers#referral-form" className="btn-outline whitespace-nowrap !px-4" data-testid="header-referral-btn">Make a Referral</Link>
          <Link to="/request-trial" className="btn-primary whitespace-nowrap !px-4" data-testid="header-trial-btn">Request a Trial</Link>
        </div>
        <button type="button" className="btn-outline !min-h-[48px] !px-3 min-[1800px]:hidden" aria-expanded={open} aria-controls="mobile-nav"
          onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}<span>{open ? "Close" : "Menu"}</span>
        </button>
      </div>
      {open && (
        <nav id="mobile-nav" aria-label="Main mobile" className="border-t border-line bg-surface min-[1800px]:hidden" data-testid="mobile-nav">
          <ul className="container-x grid gap-1 py-4 sm:grid-cols-2">
            {[...NAV, ...EXTRA].map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} onClick={() => setOpen(false)} className={({ isActive }) => `flex min-h-[52px] items-center rounded-xl px-4 text-lg font-medium ${isActive ? "bg-teal-soft text-teal" : "hover:bg-sand"}`}>{n.label}</NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
}
